module.exports = __webpack_public_path__ + "static/media/gesture-assessment.11db173f.png";